export const shouldUseCache = (config) =>
  config.method === "get" ? (config.useCache ?? false) : false;
